/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  ForgeHeader.tsx
 *
 * Project Title :  Checkout
 *
 * Description    :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : 
 *
 * On            : 
 *
 * @Version      : Version 1.0
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Mar 19, 2019
 * Description   : ASDS-2443: Added Forge header and footer
 *
 * By            : H224423
 * On            : Mar 23, 2019
 * Description   : ASDS-1052 Separated Header code to separate component.
 * 
 ******************************************************************************/

import * as React from 'react';
import { Header, Icon } from '@scuf/common';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import routeConstants from '../constants/route-constants';
import { getProperty } from '../../../utils/util';
import { CheckoutServiceURL } from '../constants/checkout-constants';
import { Component, ReactNode } from 'react';

type ForgeHeaderProps = {
    firstName: string;
    lastName: string;
    fullName: string;
};

type ForgeHeaderState = {
    redirectToLogoutPage: boolean;
};

class ForgeHeader extends Component<ForgeHeaderProps, ForgeHeaderState> {
    constructor(props: ForgeHeaderProps) {
        super(props);
        this.state = {
            redirectToLogoutPage: false
        };
    }


    componentDidMount() {
        this.addCookieConsentScripts();
    }

    addCookieConsentScripts = () => {
        const script1 = document.createElement('script');
        script1.type = 'text/javascript';
        script1.src = 'https://cdn.cookielaw.org/consent/12be062f-2c66-4b0a-bc71-c931d4f2cbc1/OtAutoBlock.js';
        document.head.appendChild(script1);

        const script2 = document.createElement('script');
        script2.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
        script2.type = 'text/javascript';
        script2.setAttribute('data-document-language', 'true');
        script2.setAttribute('data-domain-script', '12be062f-2c66-4b0a-bc71-c931d4f2cbc1');
        script2.charset = 'UTF-8';
        document.head.appendChild(script2);

        const script3 = document.createElement('script');
        script3.type = 'text/javascript';
        script3.text = 'function OptanonWrapper() { }';
        document.head.appendChild(script3);
    }


    logoutUser = () => {
        this.setState({
            redirectToLogoutPage: true
        });
    }

    render(): ReactNode {
    const accountInfoUrl = getProperty(CheckoutServiceURL.MANAGE_ACCOUNT_INFO);

    if (this.state.redirectToLogoutPage) {
       return <Redirect to={routeConstants.LOGOUT} />;
    } else {
        return (
    <Header responsive={true} menu={false} isForge={false} title="Software &amp; Data Services">
    {this.props.fullName && 
    (<Header.UserProfile firstName={this.props.firstName} lastName={this.props.lastName}>
        <Header.UserProfile.Item className="userName">{'Welcome Aboard, '} {this.props.fullName}</Header.UserProfile.Item>
        <Header.UserProfile.Item href={accountInfoUrl} target="_blank"><Icon className="userIcon" name="settings" root="common" /> {'Manage My Account '}</Header.UserProfile.Item>
        <Header.UserProfile.Item onClick={this.logoutUser} data-testid="fh-logout-id"><Icon className="userIcon" name="exit" root="common"/> {'Log Out'}</Header.UserProfile.Item>
    </Header.UserProfile>) }
    </Header>
    );
    }
    }
}
function mapStateToProps(state) {
    return {
        firstName : state.userValidationData.payload.userInfo.given_name,
        lastName : state.userValidationData.payload.userInfo.family_name,
        fullName : state.userValidationData.payload.userInfo.name,
    };
}

export default connect(mapStateToProps)(ForgeHeader);